import { useState } from 'react';

import { ApiError } from '@solar/api-client';
import { ErrorBox, Field, Spinner, useAsync } from '@solar/ui';

import { api } from '../api';

/**
 * 지원 가능 용량 관리 — 레거시 define/capacity 파리티.
 * 첫 행 하나만 읽고 고치는 단일값이라 목록 없이 패널 하나로 구성한다.
 */
export function CapacityManage() {
  const current = useAsync(() => api.getCapacity(), []);
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);

  async function save() {
    const n = Number(value);
    if (value.trim() === '' || !Number.isFinite(n) || n < 0) {
      setError('0 이상의 용량을 입력해 주세요.');
      return;
    }
    setBusy(true);
    setError(null);
    setOk(null);
    try {
      await api.setCapacity(Math.trunc(n));
      setValue('');
      setOk('저장했습니다.');
      current.reload();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : '저장하지 못했습니다.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="admin__body admin__body--single">
      <section className="admin__list">
        <div className="detail create-form">
          <div className="detail__head">
            <h2>지원 가능 용량 관리</h2>
          </div>

          {current.loading && <Spinner />}
          {current.error && <ErrorBox message={current.error} onRetry={current.reload} />}

          {!current.loading && !current.error && (
            <section className="panel">
              <Field label="현재 용량">
                {current.data ? `${current.data.capacity}W` : '등록된 값이 없습니다.'}
              </Field>
              {current.data?.year && <Field label="년도">{current.data.year}</Field>}

              <label className="labeled">
                지원 가능 용량 *
                <input
                  type="number"
                  min={0}
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder="W"
                />
              </label>

              {error && <p className="error">{error}</p>}
              {ok && <p className="ok">{ok}</p>}

              <div className="row form-actions">
                <button type="button" className="primary" disabled={busy} onClick={() => void save()}>
                  {busy ? '저장 중…' : '저장'}
                </button>
              </div>
            </section>
          )}
        </div>
      </section>
    </div>
  );
}
